import { useMutation } from "@tanstack/react-query";
import { Account } from "api/types/Account";
import AccountForm from "components/forms/account-form";
import Calculator from "components/panes/Calculator";
import PaneNavigator from "components/ui/pane-navigator";
import { PaneNavigatorHandle } from "components/ui/pane-navigator/pane-navigator";
import { useStore } from "hooks";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function AccountPage() {
  const navigate = useNavigate();
  const navigator = useRef<PaneNavigatorHandle>(null);
  const { id } = useParams();
  const { profileStore } = useStore();
  const [data, setData] = useState<Partial<Account>>({});
  const {
    data: createResonse,
    isSuccess,
    mutate,
  } = useMutation({ mutationFn: profileStore.updateAccount });

  // useEffect(() => {
  //   if (isSuccess) {
  //     onComplete(createResonse);
  //   }
  // }, [isSuccess, onComplete, createResonse]);

  useEffect(() => {
    if (id) {
      const account = profileStore.getAccountById(parseInt(id));
      if (account) {
        setData(account);
      } else {
        navigate(-1);
      }
    }
  }, [id, profileStore, navigate]);

  const handleSubmit = (values: Partial<Account>) => {
    /* @ts-ignore */
    mutate(
      { id: `${id}`, ...values },
      {
        onSuccess: () => {
          navigate(-1);
        },
        onError: (error) => {
          console.error("Error updating account:", error);
        },
      }
    );
  };

  const goBack = () => {
    navigator.current?.goBack();
  };

  const handleNameChange = (value: string) => {
    setData({ ...data, name: value });
  };

  const handleColorChange = (value: string) => {
    setData({ ...data, color: value });
  };

  const handleBalanceChange = (value: number) => {
    setData({ ...data, initialBalance: value });
    goBack();
  };

  const handleAccountNumberChange = (value: string) => {
    setData({ ...data, account_number: value });
  };

  const openBalance = () => {
    navigator.current?.navigateTo(
      <Calculator
        onAccept={handleBalanceChange}
        onCancel={goBack}
        amount={data?.initialBalance ?? 0}
      />
    );
  };

  return (
    <PaneNavigator ref={navigator}>
      <AccountForm
        onNameChange={handleNameChange}
        data={data}
        onAccountNumberChange={handleAccountNumberChange}
        onColorChange={handleColorChange}
        onBalanceClick={openBalance}
        onCancel={() => navigate(-1)}
        onSubmit={handleSubmit}
      />
    </PaneNavigator>
  );
}
